<template>
    <select v-model="internalValue" class="form-control">
        <option value="Tidak Lulus">Tidak Lulus</option>
        <option value="Lulus">Lulus</option>
        <option value="Lulus Tanpa Sertifikat">Lulus Tanpa Sertifikat</option>
        <option value="Lulus Kasus Khusus">Lulus Kasus Khusus</option>
        <option value="Selesai">Selesai</option>
    </select>
</template>

<script>
export default {
    data() {
        return {
            internalValue: this.value,
        };
    },
    props: {
        value: {
            type: String,
            default: "Tidak Lulus",
        },
    },
    watch: {
        internalValue(newValue) {
            if (newValue != this.value) this.$emit("input", newValue);
        },
        value(newValue) {
            if (newValue != this.internalValue) this.internalValue = newValue;
        },
    },
};
</script>
